import styled from "styled-components";

export const GeneratorChartTickMarkContainer = styled.div<{ left?: number; top?: number; isRotated?: boolean }>`
   
  position: absolute;
  z-index: 0;
  font-size: .8em;
  min-width: max-content;
  display: block;

  &.horizontal {
    transform: translate(-100%, -50%);
    left: 0;
    padding-right: 1em;
    top: ${({ top }) => `${top || 0}px`};
  }

  &.vertical {
    transform: translate(-50%, 60%);
    text-align: center;
    top: 100%;
    left: ${({ left }) => `${left || 0}px`};

    &.is-rotated {
      text-align: right;
      transform: rotate(-45deg) translate(-95%, -17%);   
    }
  }

`

export const GeneratorChartTickMarksAxisContainer = styled.div`
 
    position: absolute;
    left: 0;

  
    &.left {
      
      top: 0;
 
      
      .tick-mark {
        text-align: right;
        transform: translate(-100%, -50%);
      }
    }

    &.right {
      left: 100%;
      top: 0;
      transform: translateX(1em);
      
      .tick-mark {
        text-align: left!important;
        transform: translate(0, -50%);
      }
    }

    &.has-overlap {
      .tick-mark:nth-child(even) {
        visibility: hidden;
      }
    }

    .tick-mark {
      position: absolute;
    }
 
`